import { EAppTemplateType } from 'templates-common-library/baseClasses/CompatibilityChecker';
import { PublishMode, PublishUI } from '../widgets/PublishForm';

const CATEGORY: string = "Instant Apps Gallery"

export function logCapabilitySearch(
  telemetry: any,
  selectionValue: string,
  currentTab: string,
  currentCapabilityCount: number
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: "Capability Search Selection",
    label: selectionValue,
    attribute: currentTab,
    details: currentCapabilityCount
  });
}

export function logInstantAppPublish(
  telemetry: any,
  currentTab: string,
  templateTypeUrl: string,
  publishMode: PublishMode,
  publishUI: PublishUI
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: `Publish - ${currentTab}`,
    label: templateTypeUrl,
    details: publishMode,
    attribute: publishUI === "modal" ? "Create Modal" : "Preview Modal",
  });
}

export function logAppStudioCreation(
  telemetry: any,
  templateTypeUrl: EAppTemplateType,
  isSuccess: boolean,
  extraInfo: string
) {
  telemetry.logEvent({
    category: CATEGORY,
    action: `AppStudio Companion App Creation`,
    label: templateTypeUrl,
    details: isSuccess ? "success" : "failure", // "success" or "failure"
    attribute: extraInfo, // either the url to created item or the failure message
  });
}